import { render, staticRenderFns } from "./info3.vue?vue&type=template&id=c1969dd4"
import script from "./info3.vue?vue&type=script&lang=js"
export * from "./info3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports